import Transform from "@ember-data/serializer/transform";
import Protocol from "parog-web/models/protocol";

export default class ProtocolsTransform extends Transform {
  deserialize(serialized: object[]) {
    return serialized?.map((protocol): Protocol => Protocol.new(protocol));
  }

  serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    protocols: ProtocolsTransform;
  }
}
